import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title, ModalHandler } from "components/misc";
import { networkErrorHelper, adminService } from "libs";
import { MTable } from "components/table";
import { Container, Row, Col, Button } from "design-react-kit";
import dayjs from "dayjs";

export class ContactRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rndKey: 0,
      payload: [],
      type: "percorsi_abilitanti",
      pagination: {
        currentPage: 1,
        pageSize: 100,
        totalPages: 1,
        totalItems: 0,
      },
    };
  }

  //--- ---

  tableConfig = {
    columns: [
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "email",
        Header: "Email",
        accessor: "email",
      },
      {
        id: "mobile",
        Header: "Telefono",
        accessor: "mobile",
      },
      {
        id: "choices",
        Header: "Scelta (Classe - Regioni)",
        accessor: "choices",
        Cell: ({ value }) => {
          if (!value || value.length === 0) return <span>Nessuna scelta</span>;

          return (
            <ul className="pl-3 mb-0" style={{ listStyleType: "none" }}>
              {value.map((choice, index) => (
                <li key={index}>{choice}</li>
              ))}
            </ul>
          );
        },
      },
    ],
  };

  //--- ---

  changePage = (newPage) => {
    this.setState(
      (prevState) => {
        if (newPage < 1 || newPage > prevState.pagination.totalPages || newPage === prevState.pagination.currentPage) {
          return null;
        }

        return {
          pagination: {
            ...prevState.pagination,
            currentPage: newPage,
          },
        };
      },
      () => {
        this.loadRemote();
      },
    );
  };

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote() {
    this.setState({ loading: true });

    const { type, pagination } = this.state;
    const { currentPage, pageSize } = pagination;

    const payload = {
      type,
      page: currentPage,
      limit: pageSize,
    };

    adminService
      .loadContactRequests(payload)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const itemsArray = [];

        const { items, totalPages, totalItems } = data.payload.contactRequests;

        Object.entries(items).forEach(([key, val]) => {
          const choices = val.metadata.map((item) => `${item.competitionClass} - ${item.regions}`);
          val.choices = choices;

          itemsArray.push(val);
        });

        this.setState({
          loading: false,
          payload: itemsArray,
          rndKey: Math.floor(Math.random() * 1000 + 1),
          pagination: {
            ...pagination,
            currentPage: currentPage,
            totalPages: parseInt(totalPages) || 1,
            totalItems: parseInt(totalItems) || 0,
          },
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }

        this.setState({ loading: false });
      });
  }

  // --- REPORT ANALITICO ---
  onExport = () => {
    ModalHandler.show(
      null,
      "Esporta report analitico",
      "Verrà esportato il report analitico delle adesioni per i Percorsi Abilitanti per Docenti 30, 36, 60 CFU - A.A. 2026/2027. Vuoi procedere?",
      null,
      this.confirmExport,
    );
  };

  confirmExport = () => {
    this.setState({ loading: true });

    const { type } = this.state;

    adminService
      .exportContactRequests(type)
      .then(({ data }) => {
        const originalName = "report_analitico_adesioni_percorsi_abilitanti_" + dayjs().format("DD_MM_YYYY_H_m_s") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  // --- REPORT SINTETICO ---
  onExportSummary = () => {
    ModalHandler.show(
      null,
      "Esporta report sintetico",
      "Verrà esportato il report sintetico delle adesioni per i Percorsi Abilitanti per Docenti 30, 36, 60 CFU - A.A. 2026/2027. Vuoi procedere?",
      null,
      this.confirmExportSummary,
    );
  };

  confirmExportSummary = () => {
    this.setState({ loading: true });

    const { type } = this.state;

    adminService
      .exportContactRequestSummary(type)
      .then(({ data }) => {
        const originalName = "report_sintetico_adesioni_percorsi_abilitanti_" + dayjs().format("DD_MM_YYYY_H_m_s") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { loading, payload, rndKey } = this.state;
    const { currentPage, totalPages, totalItems } = this.state.pagination;
    const isExportDisabled = loading || !payload || payload.length === 0;

    return (
      <>
        <Title>Lista adesioni Percorsi Abilitanti</Title>
        <hr />
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <Container>
              <Row className="mb-4 mt-3 align-items-center">
                <Col>
                  <Button className="mx-1 float-right" color="primary bg-dark" onClick={this.onExport} disabled={isExportDisabled}>
                    Report analitico
                  </Button>

                  <Button className="mx-1 float-right" color="primary bg-dark" onClick={this.onExportSummary} disabled={isExportDisabled}>
                    Report sintetico
                  </Button>
                </Col>
              </Row>

              <MTable key={rndKey} tableData={payload} tableConfig={this.tableConfig} />

              {payload.length === 0 && (
                <BoxDanger key="nrp-1" className="my-3">
                  <div className="small text-info">Non ci sono dati da mostrare in database.</div>
                </BoxDanger>
              )}

              <div className="d-flex justify-content-center align-items-center mt-4 gap-3">
                <button
                  type="button"
                  className="btn btn-primary bg-dark mr-2"
                  onClick={() => this.changePage(currentPage - 1)}
                  disabled={loading || currentPage <= 1}
                >
                  Precedente
                </button>

                <div className="small text-muted">
                  Pagina {currentPage} di {totalPages} · Totale record: {totalItems}
                </div>

                <button
                  type="button"
                  className="btn btn-primary bg-dark ml-2"
                  onClick={() => this.changePage(currentPage + 1)}
                  disabled={loading || currentPage >= totalPages}
                >
                  Successiva
                </button>
              </div>
            </Container>
          )}
        </section>
      </>
    );
  }
}
